module.exports = __webpack_public_path__ + "static/media/envoyer-message.c5e82e42.png";